import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { PROVINCEDRPDATA } from "../../../App.config";
import DropdownComponent from "../../../containers/Dropdown";

const PayrollInformation = ({
  state,
  onDateChange,
  handleChanges,
  onDropDownChange,
  previousStep,
  onSubmit,
}) => {
  return (
    <>
      <div className="Dashboard-Content">
        <div className="Inner-cell">
          <div className="Panel-cell">
            <div className="Panel-header">
              {/* <div className="p-img">
                <img src={Compensation} alt="" />
              </div> */}
              <h2>
                <span>Payroll Information</span>
              </h2>
              {/* <legend>EMPLOYER INFORMATION</legend> */}
            </div>
            <div className="panel-content">
              <div className="Custom-form">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">Social Insurance Number:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="socialInsuranceNumber"
                        value={state.socialInsuranceNumber.value}
                        onChange={handleChanges}
                      />
                      {state.socialInsuranceNumber?.error && (
                        <span className="error">
                          {state.socialInsuranceNumber.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        Pay Method:
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <ul>
                        <li className="Radio-box">
                          <div className="check-col">
                            <input
                              type="radio"
                              tabIndex="-1"
                              id="By-Yes"
                              name="payMethod"
                              value="Cheque"
                              checked={state.payMethod.value === "Cheque"}
                              onChange={handleChanges}
                            />
                            <label htmlFor="By-Yes">Cheque</label>
                          </div>
                          <div className="check-col">
                            <input
                              type="radio"
                              tabIndex="-1"
                              id="By-No"
                              name="payMethod"
                              value="Deposit"
                              checked={state.payMethod.value === "Deposit"}
                              onChange={handleChanges}
                            />
                            <label htmlFor="By-No">Direct Deposit</label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">Banking Information:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="bankingInformation"
                        value={state.bankingInformation.value}
                        onChange={handleChanges}
                      />
                      {state.bankingInformation?.error && (
                        <span className="error">
                          {state.bankingInformation.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="">Notes</label>
                      <input
                        type="text"
                        name="notes"
                        value={state.notes.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.notes?.error && (
                        <span className="error">{state.notes.error}</span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="panel-footer margn-50">
                      <a
                        tabIndex="0"
                        onClick={previousStep}
                        className="btn btn-primary"
                      >
                        Previous
                      </a>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="panel-footer text-right margn-50">
                      <a
                        tabIndex="0"
                        onClick={onSubmit}
                        className="btn btn-primary"
                      >
                        Save
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PayrollInformation;
